import { render, staticRenderFns } from "./DistributionVehicles.vue?vue&type=template&id=10b40d31&"
import script from "./DistributionVehicles.vue?vue&type=script&lang=js&"
export * from "./DistributionVehicles.vue?vue&type=script&lang=js&"
import style0 from "./DistributionVehicles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports